/***动态分享 */
// css文件中不要使用import
import '../css/reset.css';
import '../css/index.css';
import '../css/share.css';

import './lib/object.assign';
import './lib/promise';
import './component/SM/index';
import './component/TD'; // 同盾防刷
// import './component/F5/index';

import React, {Component} from 'react';
import ReactDOM, {render} from 'react-dom';
import FastClick from 'c-fastclick';
FastClick.attach(document.body);

import url from 'c-url';
import Env from 'c-nenv';
import native from 'c-up-native';

require('./base/video');

import Auth from './feedshare/auth';
import Topic from './topic/index';
import Dynamic from './dynamic/index';
let feature = url.query('feature');
if(feature == '6666'){
    window.isUpVoice = 1;
    native.changeVoiceDeeplink();
}

let platform = native.getPlatform();

if(location.host == 'm.upliveapps.com'){
    let url = location.href.replace('m.upliveapps.com','h5.upliveapp.com');
    url = url.replace(/^http:/,'https:');
    location.href = url;
    throw SyntaxError();
}
if(location.host == 'h5.upliveapp.com' || location.host == 'm.upliveapps.com' ){
    if(location.protocol == 'http:'){
        location.href = location.href.replace(/^http:/,'https:');
        throw SyntaxError();
    }
}

const shareType = url.query('shareType') || 1; // 1动态;  2话题

let UserAuth;

if (shareType == 2){
    // 话题
    UserAuth = Auth(Topic);
} else {
    // 动态
    UserAuth = Auth(Dynamic);
}

render(<UserAuth/>, $('#wrap')[0]); 

if (Env.platform.isWeixin) {
	//解决IOS微信webview后退不执行JS的问题
	window.onpageshow = function(event) {
	    if (event.persisted) {
	        window.location.reload();
	    }
	};
}




// WEBPACK FOOTER //
// ./js/app-v2.js